import React from "react";
import { FaPlay } from "react-icons/fa";


const WhoToday = () => {
  return (
    <section className="rs-about-area section-space rs-about-thirteen my-5 py-5">
      <div className="container">
        <div className="row g-5 justify-content-center section-title-space align-items-center mb-1">
          <div className="col-xxl-6 col-xl-6 col-lg-6">
            <div className="rs-section-title-wrapper text-center">
              <span className="rs-section-subtitle has-theme-orange">
                <FaPlay color="#EA5501" size={12} />
                Who
              </span>
              <h2 className="rs-section-title rs-split-text-enable split-in-fade">
                We Are Today
              </h2>
            </div>
          </div>
        </div>
        <div className="row align-items-xxl-center g-5">
          {/* Right Content */}
          <div className="col-xl-12 col-lg-12">
            <div className="rs-about-wrapper">
              <div className="rs-about-content-wrapper">
                <div className="rs-section-title-wrapper">
                  {/* <span className="rs-section-subtitle has-theme-orange justify-content-start">
                    <FaPlay color="#EA5501" size={12} />
                    Who
                  </span>

                  <h2 className="rs-section-title rs-split-text-enable split-in-fade">
                    We Are Today
                  </h2> */}

                  <p
                    className="descrip text-justify"
                    style={{ textAlign: "justify" }}
                  >
                    Today, Eque Group stands as a diversified business house
                    with nine sister concerns operating across manufacturing,
                    energy, hospitality, and export sectors. The Group continues
                    to grow with a commitment to quality, sustainability, and
                    innovation.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoToday;
